import { render, staticRenderFns } from "./LibraryFolder.vue?vue&type=template&id=983b0fee&scoped=true"
import script from "./LibraryFolder.vue?vue&type=script&lang=js"
export * from "./LibraryFolder.vue?vue&type=script&lang=js"
import style0 from "./LibraryFolder.vue?vue&type=style&index=0&id=983b0fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b0fee",
  null
  
)

export default component.exports